import { useContext } from 'react';
import Image from 'next/image';
import { useRouter } from 'next/router';
import { NewPlanStages, policyDetailsInitState } from './constants';
import { getImageBasePath } from 'utils/generics';
import { useFetchParams } from 'hooks/useFetchParams';
import MobileModal from './mobileModels';
import Plans from './plans';
import ScanIMEI from './scanImei';
import DocumentUpload from './documentUpload';
import CustomerLink from './customerLink';
import Congratulations from 'widgets/congratulations';
import { MPosContext } from 'utils/context';
import * as Styles from './styles';
import CustomerDeviceDetails from './customerDeviceDetails';
import OrderSummary from 'components/orderSummary';
import GSTDetailsUpdateModal from 'components/dashboard/gstDetailsUpdateModal';
import { useViewport } from 'utils/responsive';
import { ModalMobile, ModalDesktop } from '@acko-tech/building-blocks.ui.modal';

function NewPlan() {
    const { lob } = useFetchParams();

    const router = useRouter();

    const {
        activeStage: stage,
        partnerId,
        setActiveStage,
        permissions,
        gstDetailsValid,
        setPlanDetails,
    } = useContext(MPosContext);

    const { isMobile } = useViewport();

    const onBack = () => {
        switch (stage) {
            case NewPlanStages.MODEL:
                router.push(`/${lob}/${partnerId}/dashboard`);
                return;
            case NewPlanStages.PLAN:
                setPlanDetails({ ...policyDetailsInitState });
                setActiveStage(NewPlanStages.MODEL);
                return;
            case NewPlanStages.IMEI:
                setActiveStage(NewPlanStages.PLAN);
                return;
            case NewPlanStages.DOCUMENT_UPLOAD:
                if (permissions.purchase_journey === 'v0') {
                    setActiveStage(NewPlanStages.IMEI);
                } else {
                    setActiveStage(NewPlanStages.CUSTOMER_DEVICE_DETAILS);
                }
                return;
            case NewPlanStages.CUSTOMER_DEVICE_DETAILS:
                setActiveStage(NewPlanStages.PLAN);
                return;
            case NewPlanStages.CUSTOMER_LINK:
                setActiveStage(NewPlanStages.DOCUMENT_UPLOAD);
                return;
            case NewPlanStages.SUMMARY:
                setActiveStage(NewPlanStages.DOCUMENT_UPLOAD);
                return;
            case NewPlanStages.CONGRATULATION:
                router.push(`/${lob}/${partnerId}/dashboard`);
                return;
            default:
                setActiveStage(NewPlanStages.MODEL);
        }
    };

    const activeNewPlanStage = () => {
        switch (stage) {
            case NewPlanStages.MODEL:
                return <MobileModal />;
            case NewPlanStages.PLAN:
                return <Plans />;
            case NewPlanStages.CUSTOMER_DEVICE_DETAILS:
                return <CustomerDeviceDetails />;
            case NewPlanStages.IMEI:
                return <ScanIMEI />;
            case NewPlanStages.DOCUMENT_UPLOAD:
                return <DocumentUpload />;
            case NewPlanStages.CUSTOMER_LINK:
                return <CustomerLink />;
            case NewPlanStages.SUMMARY:
                return <OrderSummary />;
            case NewPlanStages.CONGRATULATION:
                return (
                    <Congratulations
                        message={`Plan details shared with customer, waiting for customer to pay`}
                    />
                );
            default:
                return <MobileModal />;
        }
    };

    const Modal: any = isMobile ? ModalMobile : ModalDesktop;

    return (
        <Styles.Wrapper>
            <Styles.Header>
                <Styles.BackArrowIcon>
                    <Image
                        width={'10px'}
                        height={'24px'}
                        alt={''}
                        src={getImageBasePath('/icons/backArrow.svg')}
                        onClick={onBack}
                    />
                </Styles.BackArrowIcon>
            </Styles.Header>
            {activeNewPlanStage()}
            {!gstDetailsValid && (
                <Modal
                    show={true}
                    urlhash={''}
                    onHide={() => {}}
                    padding={'20px'}
                    maxWidth={'500px'}
                    wrapperStyles={`border-radius: 16px 16px 0px 0px;`}
                    showOverlayBackground={true}
                    hideCloseButton={true}
                >
                    <GSTDetailsUpdateModal />
                </Modal>
            )}
        </Styles.Wrapper>
    );
}

export default NewPlan;
